import { render, staticRenderFns } from "./PaymentMethodDelete.vue?vue&type=template&id=55c93fc4&"
import script from "./PaymentMethodDelete.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports